import React, { useEffect, useState } from 'react'
import {  Sidebar, Menu, MenuItem, SubMenu, menuClasses, } from 'react-pro-sidebar';

import { getUsuarioStorage } from '../helpers/getUsuarioStorage'
import { UsuarioPassword } from './usuarioPassword';

import { useGetPantallas } from '../hooks/useGetPantallas';

import {
    Link,
    
    
} from "react-router-dom";

const themes = {
    light: {
        sidebar: {
        backgroundColor: '#ffffff',
        color: '#607489',
        },
        menu: {
        menuContent: '#fbfcfd',
        icon: '#0098e5',
        hover: {
            backgroundColor: '#c5e4ff',
            color: '#44596e',
        },
        disabled: {
            color: '#9fb6cf',
        },
        },
    },
    dark: {
        sidebar: {
        backgroundColor: '#0b2948',
        color: '#8ba1b7',
        },
        menu: {
        menuContent: '#082440',
        icon: '#59d0ff',
        hover: {
            backgroundColor: '#00458b',
            color: '#b6c8d9',
        },
        disabled: {
            color: '#3e5e7e',
        },
        },
    },
};



const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const SideMenu = ( {ocultarMenu, collapsed, toggled, retToggleMenu } ) => {
  
    const [collapsedMenu, setCollapsedMenu] = useState(collapsed);
    const [toggledMenu, setToggledMenu] = useState(toggled);
    // const [broken, setBroken] = useState(false);
    const [theme] = useState('dark');
    const [hasImage] = useState(false);
    
    const [show, setShowPassword] = useState(false);
    const handleShowPassword = () => setShowPassword(true);


    let [usuario] = useState( getUsuarioStorage() )

    const pantallas = useGetPantallas();
    // pantallas.includes("escritorios", 0)
    
    const menuItemStyles = {
        root: {
        // fontSize: '13px',
            fontWeight: 400,
        },
        icon: {
            color: themes[theme].menu.icon,
            [`&.${menuClasses.disabled}`]: {
                color: themes[theme].menu.disabled.color,
            },
        },
        SubMenuExpandIcon: {
            color: '#b6b7b9',
        },
        subMenuContent: ({ level }) => ({
            backgroundColor:
                level === 0
                ? hexToRgba(themes[theme].menu.menuContent, hasImage && !collapsed ? 0.4 : 1)
                : 'transparent',
            }),
            button: {
                [`&.${menuClasses.disabled}`]: {
                    color: themes[theme].menu.disabled.color,
                },
                '&:hover': {
                    backgroundColor: hexToRgba(themes[theme].menu.hover.backgroundColor, hasImage ? 0.8 : 1),
                    color: themes[theme].menu.hover.color,
                },
            },
            label: ({ open }) => ({
                fontWeight: open ? 600 : undefined,
            }),
    };

    useEffect(() => {
      setCollapsedMenu(collapsed);
      setToggledMenu(toggled);
    }, [collapsed, toggled])
    

    const handleToggle = () =>{
        setToggledMenu(toggledMenu)
        retToggleMenu(toggledMenu)
        
    }

//    console.log(collapsedMenu)
    
    return (
        <div style={{ display: 'contents',  }}>
            
            <Sidebar
                collapsed={ !toggledMenu ? collapsedMenu : !collapsedMenu }
                toggled={!collapsedMenu ? toggledMenu : !toggledMenu }
                // onBreakPoint={setBroken}
                breakPoint= { toggledMenu ? undefined : 'sm' }
                // breakPoint= 'always'
                backgroundColor={hexToRgba(themes[theme].sidebar.backgroundColor, hasImage ? 0.9 : 1)}
                rootStyles={{
                    color: themes[theme].sidebar.color,
                    // position: 'revert',
                    position: 'sticky',
                    // minHeight: '',
                    height: 'auto' ,
                    width:"15%",
                    // top: 60,
                    overflowY: "visible",
                }}
                
                
            >
                              
                <Menu menuItemStyles={menuItemStyles} >
                    <div 
                        className='mt-3 mb-3'
                        style={{ display: collapsedMenu === false ? "block" : "none", padding: '0 24px',  textAlign: 'center', letterSpacing: '0.5px', }}>
                        <div  style={{ fontWeight: '600', cursor: 'pointer' }} onClick={ handleShowPassword } >  {usuario.agente} </div>
                        <div >  {usuario.modulo} </div>
                        <hr />
                    </div>

                    < div className='mt-3' >
                        {
                            pantallas.includes("escritorios") 
                            ? 
                            (    <MenuItem 
                                    icon={ <i className="fa-solid fa-desktop"></i>}  
                                    component={< Link to="/modulo" />}
                                    onClick={handleToggle}
                                >
                                    Modulo
                                </MenuItem>
                            ) : ""
                        }

                        {
                            pantallas.includes("tiposatencion") ||
                            pantallas.includes("creacionescritorios") ||
                            pantallas.includes("usuarios") || 
                            pantallas.includes("videoslistas") 
                            ? (
                                <SubMenu icon={ <i className="fa-solid fa-house"></i>} label="Administración" >
                                        { pantallas.includes("tiposatencion") 
                                            ? (
                                                <MenuItem 
                                                    // icon={ <i className="fa-solid fa-rectangle-list"></i>}  
                                                    component={< Link to="/tiposAtencion" />}
                                                    onClick={handleToggle}

                                                >
                                                    Tipos de Atención
                                                </MenuItem>
                                            ) : ""
                                        }

                                        { pantallas.includes("creacionescritorios") 
                                            ? (
                                                <MenuItem 
                                                    // icon={ <i className="fa-solid fa-rectangle-list"></i>}  
                                                    component={< Link to="/modulos-creacion" />}
                                                    onClick={handleToggle}
                                                >
                                                    Módulos
                                                </MenuItem>
                                            ) : ""
                                        }

                                        { pantallas.includes("tiposatencion") 
                                            ? (
                                                <MenuItem 
                                                    // icon={ <i className="fa-solid fa-rectangle-list"></i>}  
                                                    component={< Link to="/modulos-tiposAtencion" />}
                                                    onClick={handleToggle}
                                                >
                                                    Módulos / Atenciones
                                                </MenuItem>
                                            ) : ""
                                        }

                                        { pantallas.includes("usuarios") 
                                            ? (

                                                <MenuItem 
                                                    // icon={ <i className="fa-solid fa-rectangle-list"></i>}  
                                                    component={< Link to="/usuarios" />}
                                                    onClick={handleToggle}
                                                >
                                                    Usuarios
                                                </MenuItem>
                                            ) : ""
                                        }

                                        { pantallas.includes("videoslistas") 
                                            ? (

                                                <MenuItem 
                                                    // icon={ <i className="fa-solid fa-rectangle-list"></i>}  
                                                    component={< Link to="/lista-videos" />}
                                                    onClick={handleToggle}
                                                >
                                                    Lista de Videos
                                                </MenuItem>
                                            ) : ""
                                        }
                                    
                                        {/* <SubMenu icon={ <i className="fa-solid fa-house"></i>} label="Charts" >

                                            <MenuItem> Pie charts </MenuItem>
                                            <MenuItem> Line charts </MenuItem>
                                        </SubMenu> */}
                                </SubMenu>
                            ): ""

                        }

                        {
                            pantallas.includes("informes") ||
                            pantallas.includes("listapacientes") 
                            ? (
                                <SubMenu icon={ <i className="fa-solid fa-chart-gantt"></i>} label="Informes" >
                                        { pantallas.includes("informes") 
                                            ? (
                                                <MenuItem 
                                                    // icon={ <i className="fa-solid fa-rectangle-list"></i>}  
                                                    component={< Link to="/informes" />}
                                                    onClick={handleToggle}

                                                >
                                                    Dashboard
                                                </MenuItem>
                                            ) : ""
                                        }

                                        { pantallas.includes("listapacientes") 
                                            ? (
                                                <MenuItem 
                                                    // icon={ <i className="fa-solid fa-rectangle-list"></i>}  
                                                    component={< Link to="/lista-Pacientes" />}
                                                    onClick={handleToggle}
                                                >
                                                    Lista Pacientes
                                                </MenuItem>
                                            ) : ""
                                        }

                                        
                                </SubMenu>
                            ): ""

                        }

                       

                        {/* <MenuItem> Documentation </MenuItem>
                        <MenuItem> Calendar </MenuItem> */}
                    </div>    
                    
                </Menu>
            </Sidebar>
            
            <UsuarioPassword 
                show={ show } 
                onHide={() => setShowPassword(false) }
            />
        </div>
        
    )
}

